import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentparameters from '../components/componentparameters'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './eminence.css'

const Eminence = (props) => {
  return (
    <div className="eminence-container">
      <Helmet>
        <title>
          Arcobo Eminence | WAAM-принтер для титана и никелевых сплавов
        </title>
        <meta
          name="description"
          content="Промышленная WAAM-система с защитной атмосферой для печати титановых и никелевых жаропрочных сплавов. Для авиации, энергетики и высокотехнологичных производств."
        />
        <meta
          property="og:title"
          content="Arcobo Eminence | WAAM-принтер для титана и никелевых сплавов"
        />
        <meta
          property="og:description"
          content="Промышленная WAAM-система с защитной атмосферой для печати титановых и никелевых жаропрочных сплавов. Для авиации, энергетики и высокотехнологичных производств."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Arcobo Eminence | WAAM-принтер для титана и никелевых сплавов"
        />
        <meta
          name="twitter:description"
          content="Промышленная WAAM-система с защитной атмосферой для печати титановых и никелевых жаропрочных сплавов. Для авиации, энергетики и высокотехнологичных производств."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/eminence"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/eminence"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Eminence","item":"https://arcobo.tech/eminence"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name9"></HeaderMain>
      <hr className="eminence-separator1"></hr>
      <Componenttextimage
        image1Src="/2_3D Printing/2_3_3D Printers/eminence_v2-1500w.webp"
        image1Alt="3D-принтер Arcobo Eminence"
        rootClassName="componenttextimageroot-class-name13"
        textComponent={
          <Fragment>
            <span className="eminence-text100">
              <span className="eminence-text101 H1_extrasmall">
                Промышленная WAAM-система для печати активных металлов в
                полностью инертной атмосфере
              </span>
              <br></br>
              <span className="text_large">
                Arcobo Eminence разработан для аддитивного производства деталей
                из титана, никелевых и других активных сплавов. Герметичная
                рабочая камера с контролируемой инертной атмосферой обеспечивает
                стабильное качество печати и предотвращает окисление металла на
                протяжении всего процесса.
              </span>
              <br className="text_large"></br>
              <br className="text_large"></br>
              <span className="eminence-text106 H1_small">
                Преимущества и выгоды:
              </span>
              <br className="H1_small"></br>
              <span className="eminence-text108 H1_small">✔ </span>
              <span className="eminence-text109 H1_extrasmall">
                Печать активных металлов
              </span>
              <br className="H1_extrasmall"></br>
              <span className="text_large">
                Полностью герметичная камера позволяет работать с титаном,
                Inconel, ниобием, танталом и другими материалами,
                чувствительными к воздействию кислорода.
              </span>
              <br className="text_large"></br>
              <span className="eminence-text113 text_large">✔ </span>
              <span className="eminence-text114 H1_extrasmall">
                Максимальное качество изделий
              </span>
              <br className="H1_extrasmall"></br>
              <span className="text_large">
                Контролируемая атмосфера значительно снижает образование оксидов
                и обеспечивает высокие механические свойства готовых деталей.
              </span>
              <br className="text_large"></br>
              <span className="eminence-text118 text_large">✔ </span>
              <span className="eminence-text119 H1_extrasmall">
                Экономия дорогостоящих материалов
              </span>
              <br className="H1_extrasmall"></br>
              <span className="text_large">
                Высокий коэффициент использования материала позволяет
                минимизировать отходы при работе с дорогостоящими сплавами.
              </span>
              <br className="text_large"></br>
              <span className="eminence-text123 text_large">✔ </span>
              <span className="eminence-text124 H1_extrasmall">
                Полный цикл разработки
              </span>
              <br className="H1_extrasmall"></br>
              <span className="text_large">
                Arcobo обеспечивает проектирование технологии, изготовление
                комплекса, запуск производства и обучение персонала.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Arcobo Eminence"
      ></Componenttextimage>
      <Component3images
        image1Src="/2_3D Printing/3d_01-200h.webp"
        image1Alt="WAAM 3D-печать металлом"
        image2Src="/2_3D Printing/3d_02-200h.webp"
        image2Alt="WAAM 3D-печать металлом"
        image3Src="/2_3D Printing/3d_03-200h.webp"
        image3Alt="WAAM 3D-печать металлом"
        rootClassName="component3imagesroot-class-name23"
      ></Component3images>
      <Componentparameters
        text1={
          <Fragment>
            <span className="eminence-text127">
              <span className="eminence-text128">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Промышленный робот-манипулятор</span>
              <br></br>
              <span className="eminence-text131">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Двухсевой позиционер</span>
              <br></br>
              <span className="eminence-text135">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Цифровой сварочный источник</span>
              <br></br>
              <span className="eminence-text139">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Герметичная рабочая камера</span>
              <br></br>
              <span className="eminence-text142">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система создания и поддержания инертной атмосферы</span>
              <br></br>
              <span className="eminence-text146">•</span>
              <span className="eminence-text147">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система контроля содержания кислорода</span>
              <br></br>
              <span className="eminence-text150">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система подачи сварочной проволоки</span>
              <br></br>
              <span className="eminence-text153">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система 3D-сканирования</span>
              <br></br>
              <span className="eminence-text157">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система контроля температуры детали</span>
              <br></br>
              <span className="eminence-text161">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Контроллер управления роботизированным комплексом</span>
              <br></br>
              <span className="eminence-text165">•</span>
              <span className="eminence-text166">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Программное обеспечение Arcobo WAAM</span>
              <br></br>
              <span className="eminence-text169">•</span>
              <span className="eminence-text170">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Защитная система с датчиками безопасности</span>
              <br></br>
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="eminence-text173">
              <span>
                Тип процесса:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="eminence-text175">MIG/MAG/TIG/PAW/LW</span>
              <br></br>
              <span>Онлайн-мониторинг печати:</span>
              <span className="eminence-text178"> Да</span>
              <br></br>
              <span>Производительность печати:</span>
              <span className="eminence-text181">до 5 кг/час (сталь)</span>
              <br></br>
              <span>Максимальная масса детали:</span>
              <span className="eminence-text184">1500 кг</span>
              <br></br>
              <span>
                Рабочая зона:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="eminence-text187">2400 × 2400 × 1500 мм</span>
              <br></br>
              <span>Точность позиционирования:</span>
              <span className="eminence-text190">±0,06 мм</span>
              <br></br>
              <span>
                Диаметры проволоки:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="eminence-text193">1,0-2,4 мм</span>
              <br></br>
              <span>
                Напряжение питания:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="eminence-text196">380 В, 50 Гц</span>
              <br></br>
              <span>
                Потребляемая мощность:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="eminence-text199">20–25 кВт</span>
              <br></br>
              <span>
                Атмосфера печати:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="eminence-text202">Полностью инертная</span>
              <br></br>
              <span>
                Контроль содержания:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="eminence-text205">Да</span>
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="eminence-text206">
              <span className="eminence-text207">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Технология печати целевых деталей</span>
              <br></br>
              <span className="eminence-text210">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Пусконаладочные работы</span>
              <br></br>
              <span className="eminence-text213">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Обучение персонала. Базовый курс 4 дня</span>
              <br></br>
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="eminence-text216">
              <span className="eminence-text217">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Линейная ось (до 18 м)</span>
              <br></br>
              <span className="eminence-text220">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Вращатели и позиционеры (до 5 осей в однм устройстве)</span>
              <br></br>
              <span className="eminence-text223">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Дополнительные внешние оси</span>
              <br></br>
              <span className="eminence-text226">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Стол, адаптированный под целевые деталивнешние оси</span>
              <br></br>
              <span className="eminence-text229">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Оснастка под целевые детали</span>
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="eminence-text231">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        heading1="A. Базовая комплектация"
        heading2="B. Базовые характеристики"
        heading3="C. В состав поставки включены:"
        heading4="D. Дополнительные опции"
        showDiv5={false}
        mainHeading="Характеристики Arcobo Eminence"
        rootClassName="componentparametersroot-class-name6"
      ></Componentparameters>
      <Component3images
        image1Src="/2_3D Printing/3d_11-200h.webp"
        image1Alt="Изделие WAAM 3D-печати"
        image2Src="/2_3D Printing/3d_12-200h.webp"
        image2Alt="Изделие WAAM 3D-печати"
        image3Src="/2_3D Printing/3d_13-200h.webp"
        image3Alt="Изделие WAAM 3D-печати"
        rootClassName="component3imagesroot-class-name24"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="eminence-text232">
              Изготавливаются функциональные металлические детали массой от
              нескольких килограммов до нескольких тонн: корпуса, крыльчатки,
              сопла, оснастка, пресс-формы, заготовки и детали сложной
              геометрии. ArcticWhite особенно эффективен для единичного и
              мелкосерийного производства крупногабаритных изделий.
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="eminence-text233">
              Технология наиболее эффективна при изготовлении единичных и
              мелкосерийных деталей, крупных изделий, дорогостоящих сплавов и
              деталей с длительными сроками поставки. WAAM позволяет отказаться
              от дорогостоящей литейной оснастки и значительно сократить сроки
              производства.
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="eminence-text234">
              Поддерживается печать более чем из 100 металлических сплавов,
              включая конструкционные и нержавеющие стали, инструментальные
              стали, алюминиевые, бронзовые, никелевые и титановые сплавы.
              Конкретный перечень материалов определяется конфигурацией
              комплекса.
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="eminence-text235">
              Стоимость зависит от материала, массы детали, сложности геометрии,
              объема последующей мехобработки и размера партии. Для большинства
              единичных изделий расчет выполняется индивидуально на основе
              CAD-модели.
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="eminence-text236">
              Для предприятий с регулярной потребностью в изготовлении или
              восстановлении металлических деталей инвестиции в WAAM обычно
              окупаются за счет сокращения сроков производства, снижения
              закупочных затрат и отказа от дорогостоящей оснастки. Конкретный
              срок окупаемости определяется производственной программой
              предприятия.
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="eminence-text237">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="eminence-text238">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="eminence-text239">answer</span>
          </Fragment>
        }
        showDiv5
        showDiv6
        showDiv7
        question1="Какие детали можно изготавливать?"
        question2="Когда WAAM выгоднее традиционного производства?"
        question3="Из каких материалов можно печатать?"
        question4="Сколько стоит изготовление детали методом WAAM?"
        question5="Какой срок окупаемости WAAM?"
        rootClassName="componentfaqroot-class-name12"
      ></Componentfaq>
      <hr className="eminence-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name9"></FooterMain>
    </div>
  )
}

export default Eminence
